"use strict";
// inspired from https://tobbelindstrom.com/blog/resize-observer-hook/
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useResizeObserver = () => {
    const [observerEntry, setObserverEntry] = (0, react_1.useState)({});
    const nodeRef = (0, react_1.useRef)(null);
    const observer = (0, react_1.useRef)(null);
    const disconnect = (0, react_1.useCallback)(() => { var _a; return (_a = observer.current) === null || _a === void 0 ? void 0 : _a.disconnect(); }, []);
    const observe = (0, react_1.useCallback)(() => {
        observer.current = new ResizeObserver(([entry]) => setObserverEntry(entry));
        if (nodeRef.current) {
            observer.current.observe(nodeRef.current);
        }
    }, [nodeRef]);
    (0, react_1.useLayoutEffect)(() => {
        observe();
        return () => disconnect();
    }, [disconnect, observe]);
    return [nodeRef, observerEntry];
};
exports.default = useResizeObserver;
